<template>
  <v-layout column class="code-card">
    <div class="text-xs-center font-weight-regular headline">Code SCM Data</div>
    <div class="text-xs-center caption">{{code.serial_number}}</div>
    <v-layout column class="px-3 py-2">
      <template v-for="field in scmFields">
        <template v-if="!field.immutable">
          <div :key="field.key + '-key'" class="label text-uppercase font-weight-bold px-3 py-2">{{field.label}}:</div>
          <div :key="field.key + '-val'" class="value font-weight-light px-3 py-2">{{scmData[field.key] || "—"}}</div>
        </template>
      </template>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CodeCard',
  props: {
    code: Object
  },
  computed: {
    scmFields () {
      return this.$store.getters['scmFields/scmFields'][this.code['campaign']] || []
    },
  },
  watch: {
    code() {
      if (this.code.scm_data && this.scmFields) {
        this.scmFields.forEach(field => {
          this.$set(this.scmData, field.key, this.code.scm_data[field.key])
        })
      }
    }
  },
  // beforeMount () {
  //   this.scmFields.forEach(field => {
  //     if (!this.scmData[field.key])
  //       this.$set(this.scmData, field.key, '')
  //   })
  // },
  data () {
    return {
      scmData: { }
    }
  },
}
</script>

<style lang="scss" scoped>

.code-card{
  position: relative;
}

.hash {
  font-family: monospace;
  word-break: break-all;
  text-decoration: none;
  color: #2a63d5;
}

.edit-btn{
  position: absolute;
  top: 0px;
  right: 0px;
}

.infos-container{
  padding: 10px 25px;
}

.label{
  color: #858585;
  font-size: 12px;
}

.value{
  background: white;
  font-size: 16px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.certificate .label{
  background: white;
}

.rotate{
  transform: rotateX(180deg)
}

.expand-header{
  padding: 5px 15px;
  background: #fafafa;
  cursor: pointer;
}

.expand-content{
  transition: 0.5s;
  max-height: 0;
  overflow: hidden;
}

.show-content{
  max-height: 300px;
}

.caption{
  color: #888888;
  margin-bottom: 10px;
}

.divider:after, .divider:before {
  width: 75px;
  height: 1px;
  background-color: #8888887a;
  content: "";
  display: block;
  position: relative;
}

.divider:after {
  left: 78px;
  bottom: 10px;
}

.divider:before {
  left: 235px;
  top: 10px;
}

</style>
